import { HelpOutlineOutlined } from "@mui/icons-material";
import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { useAiAdvisor } from "@ryde/redux";

import { LeftBarButton } from "./left-bar.button";

export const LeftBarHelpPageButton: FC = () => {
  const { t } = useTranslation();
  const { isBulkAIAdvisorDrawerOpen, openBulkAIAdvisorDrawer } =
    useAiAdvisor("unknown");

  return (
    <LeftBarButton
      onMenuItemClick={() => openBulkAIAdvisorDrawer()}
      tooltip={t(`chatBot.buttonTooltip`)}
    >
      <HelpOutlineOutlined
        className={clsx("svg-go-help-page", {
          active: isBulkAIAdvisorDrawerOpen,
        })}
        data-e2e="svg-help"
      />
    </LeftBarButton>
  );
};
